
import apiRequest from '../lib/api-request';


export class buildApi {
	constructor(state) {
	    this.state = state;
	}

	editPortfolio(data) {
	    return apiRequest(`user`,`edit_super_portfolio`,{"data":data});
	}

	createPortfolio(data) {
	    return apiRequest(`user`,`set_super_portfolio`,{"data":data});
	}

	backtest(data){
		return apiRequest(`backtest`,`run_full_backtest`,{"data":data});
	}
	validateEtfs(etfs, timestamp){
		return apiRequest('finance','etfs_history_exists',{"etf_tickers":etfs, "time_to_check":timestamp});
	}
	getPortfolio(){

		return apiRequest('user',"get_user_portfolio_data",{});
	}
	checkScreeners(sectorId, screeners){

		return apiRequest('user',"count_screened_symbols",{screeners:screeners, sector_id:sectorId});
	}
	getAllocation(data){
		return apiRequest('user',"get_user_portfolio_allocation",{"data":data});
	}
	getBacktestStatus(){
		return apiRequest('backtest',"check_backtest_status",{});
	}
	breakBacktest(){
		return apiRequest('backtest',"break_backtest",{});
	}
	updateTeam(){
		return apiRequest('user','auto_update_analysts_team',{});
	}
	getDefaultSectors(){
		return apiRequest('user', 'get_sectors', {});
	}
}
export default new buildApi



// WEBPACK FOOTER //
// ./src/js/actions/BuildApi.js